import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { Claims } from '../../constants/claims';

export const loginGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AuthService).decodedAccessToken ? inject(Router).createUrlTree(['./workspace/' + String(inject(AuthService).getAccessTokenClaim(Claims.DefaultWorkspacesID))]) : true;
};
